export default __webpack_public_path__ + "static/media/not-found-error.d235259e.svg";